import script from "./OnboardingSuccess.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardingSuccess.vue?vue&type=script&setup=true&lang=ts"

import "./OnboardingSuccess.vue?vue&type=style&index=0&id=9dc3d55e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dc3d55e"]])

export default __exports__